import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhenItComesToSpecialNeedsPlanningDoesTheTypeOfDisabilityMatterPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-when-it-comes-to-special-needs-planning-does-the-type-of-disability-matter/']} />;
}
